import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Link } from "react-router-dom";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import axios from "axios";
import ContentLoader from "react-content-loader";

// Placeholder loader for images
const ImageLoader = ({ width, height }) => (
    <ContentLoader speed={2} width={width} height={height} viewBox={`0 0 ${width} ${height}`} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
        <rect x="0" y="0" rx="5" ry="5" width={width} height={height} />
    </ContentLoader>
);

export default function Highlights() {
    const [activeTab, setActiveTab] = useState("highlight");
    const [highlightData, setHighlightData] = useState([]);
    const [trendData, setTrendData] = useState([]);
    const [imageLoaded, setImageLoaded] = useState({});

    const [isTabview, setIsTabView] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsTabView(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Fetch highlight and trend data on component mount
    // useEffect(() => {
    //     const getHighlightAndTrendArticle = async () => {
    //         try {
    //             const response = await axios.post(BASE_URL + "API/apicall", {
    //                 security_key: security_key,
    //                 mode: "getHighlightAndTrendArticle",
    //             });
    //             const output = response.data;
    //             if (Object.keys(output).length === 2) {
    //                 setHighlightData(output.highlight_news);
    //                 setTrendData(output.trend_news);
    //             }
    //         } catch (error) {
    //             console.error("Error fetching data:", error);
    //         }
    //     };

    //     getHighlightAndTrendArticle();
    // }, []);

    useEffect(() => {
        fetchAllHighlight();
    }, []);

    const fetchAllHighlight = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllHighlightArticles",
        });

        const output = response.data;

        const todayHighlights = output.filter((post) => post.highlight_type === 1);
        const hotAndTrending = output.filter((post) => post.highlight_type === 2);

        todayHighlights.sort((a, b) => a.highlight_order - b.highlight_order);
        hotAndTrending.sort((a, b) => a.highlight_order - b.highlight_order);

        setHighlightData(todayHighlights);
        setTrendData(hotAndTrending);
    };

    // Handle image load event
    const handleImageLoad = (index) => {
        console.log(`Image at index ${index} loaded`);
        setImageLoaded((prevState) => ({
            ...prevState,
            [index]: true,
        }));
    };

    // Function to format numbers
    const formatNumber = (num) => {
        if (num >= 1e6) {
            return (num / 1e6).toFixed(1).replace(/\.0$/, "") + "m";
        } else if (num >= 1e3) {
            return (num / 1e3).toFixed(1).replace(/\.0$/, "") + "k";
        }
        return num.toString();
    };

    return (
        <div className="mb-20">
            <div className="row font-heading mb-20">
                <div className="col-md-12 text-uppercase">
                    <nav className="tab-nav font-weight-bold">
                        <div className="nav nav-tabs" role="tablist">
                            <a
                                className={`nav-item nav-link nav-tab ${activeTab === "highlight" ? "active" : ""}`}
                                onClick={() => setActiveTab("highlight")}
                                role="tab"
                            >
                                Today Highlight
                            </a>
                            <a
                                className={`nav-item nav-link nav-tab ${activeTab === "trending" ? "active" : ""}`}
                                onClick={() => setActiveTab("trending")}
                                role="tab"
                            >
                                Hot & Trending
                            </a>
                        </div>
                    </nav>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-12">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={0}
                        autoplay={{ delay: 3000, disableOnInteraction: false }} // Enable autoplay
                        pagination={{ clickable: true }}
                        // pagination={true}
                        modules={[Pagination, Autoplay]}
                        breakpoints={{
                            320: { slidesPerView: 1 },
                            425: { slidesPerView: 1 },
                            640: { slidesPerView: 2 },
                            1024: { slidesPerView: 1 },
                        }}
                        className="mySwiper"
                    >
                        {(activeTab === "highlight" ? highlightData : trendData).map((post, index) => (
                            <SwiperSlide key={index}>
                                <Link className="text-white" to={`/detail/${post.pk_ac_key}`}>
                                    <div className="img-swipe position-relative">
                                        {post.additionalFields &&
                                            JSON.parse(post.additionalFields).map((item, i) => {
                                                if (i === 0 && item["base_type"] !== "video") {
                                                    return (
                                                        <React.Fragment key={i}>
                                                            {!imageLoaded[index] && <ImageLoader width={isTabview ? 290 : 668} height={425} />}
                                                            <img
                                                                src={IMAGE_URL + item["file_name"]}
                                                                alt="article thumbnail"
                                                                width={668}
                                                                height={425}
                                                                className="img-swiper"
                                                                style={{ display: imageLoaded[index] ? "block" : "none" }}
                                                                onLoad={() => handleImageLoad(index)}
                                                            />
                                                        </React.Fragment>
                                                    );
                                                }
                                                return null;
                                            })}
                                    </div>
                                    <div className="swiper-slide-content position-absolute bottom-0 p-20">
                                        <div className="header-swipe">
                                            <hr className="mt-2 mb-3" />
                                            <p className="text-white mb-2">
                                                {post.mod_publish_date} <span className="">{formatNumber(post.ac_view_count)} views</span>
                                            </p>
                                        </div>
                                        <h3 className="text-white swipe-head-text">{post.ac_name}</h3>
                                    </div>
                                </Link>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
            <style jsx>
                {`
                    .scroller {
                        height: 1.2em;
                        line-height: 1.2em;
                        position: relative;
                        overflow: hidden;
                        text-align: center;
                    }

                    .swiper-slide-content {
                        background: rgba(0, 0, 0, 0.4);
                        width: 100%;
                    }

                    .swiper-slide {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        position: relative;
                    }

                    .nav-tabs {
                        border: none;
                    }

                    .nav-tabs .nav-item:hover,
                    .nav-tabs .nav-link:hover,
                    .nav-tabs .nav-link:focus {
                        border-color: transparent;
                    }
                    .nav-tabs .nav-link {
                        border: none;
                    }
                `}
            </style>
        </div>
    );
}
